import AttributeType from './models/AttributeType'
import { loadAttributeType, createAttributeType, updateAttributeType, 
  loadAttributeTypeList, deleteAttributeType, storeSecondaryAttributeScraper,
  deleteSecondaryScrapers, deleteScrapers, deleteScraper
} from '@/api/super'

export default {

  namespaced: true,

  state: {
    attributeType: new AttributeType(),
    attributeTypeList: [],
    types: [
      { value: 'environment', label: 'Laravel Environment' },
      { value: 'config', label: 'Laravel Configuration' },
      { value: 'application', label: 'General Attribute' },
      { value: 'source', label: 'Source Analysis' },
      { value: 'system', label: 'System Attribute' },
    ],
    scrapers: []
  },

  mutations: {
    ...AttributeType.mutations(),
    setAttributeTypeList: (state, payload) => state.attributeTypeList = payload,
    setScrapers: (state, payload) => state.scrapers = payload,
  },

  actions: {
    store: ({ state }) => new Promise((resolve, reject) => createAttributeType(state.attributeType, resolve, reject)),
    update: ({state}) => new Promise((resolve, reject) => updateAttributeType(state.attributeType, resolve, reject)),
    loadAttributeType: ({ commit }, attributeTypeId) => new Promise((resolve, reject) => loadAttributeType(attributeTypeId, ({ data }) => {
      commit('setAttributeType', data)
      resolve()
    }, reject)),
    deleteAppMeta: ({}, attributeTypeId) => new Promise((resolve, reject) => deleteAttributeType(attributeTypeId, resolve, reject)),
    loadAttributeTypeList: ({ commit }) => new Promise((resolve, reject) => loadAttributeTypeList(({ data }) => {
      commit('setAttributeTypeList', data)
      resolve()
    }, reject)),
    storeSecondaryScraper: ({state}, payload) => new Promise((resolve, reject) => {
      storeSecondaryAttributeScraper({
        attributeId: state.attributeType.id,
        ...payload
      }, resolve, reject)
    }), 
    deleteSecondaryScrapers: ({state, commit}) => new Promise((resolve, reject) => {
      deleteSecondaryScrapers(state.attributeType.id, () => {
        commit('clearSecondaryScrapers')
        resolve()
      }, reject)
    }),
    deleteScrapers: ({state, commit}) => new Promise((resolve, reject) => {
      deleteScrapers(state.attributeType.id, () => {
        commit('clearScrapers')
        resolve()
      }, reject)
    }),
    deleteScraper: ({state, commit}, scraperId) => new Promise((resolve, reject) => {
      deleteScraper({
        attributeId: state.attributeType.id,
        scraperId
      }, () => {
        commit('removeScraper', scraperId)
        resolve()
      }, reject)
    }) 
  },

  getters: {
    attributeType: state => state.attributeType,
    attributeTypeList: state => state.attributeTypeList,
    types: state => state.types,
    scrapers: state=> state.scrapers
  }

}